import React from "react";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Tokens } from "Shared/Tokens";
import { getFormattedAmount } from "Shared/Utils";
import getCurrencySymbol from "Shared/CurrancySymbol";
import { PerformanceTag } from "Shared/PerformanceTag";

const ImportedPortfolioCard = (props) => {
    const { name = "Binance", currency } = props;

    let summary = null;
    try {
        const cached = localStorage.getItem("binance_wallet_summary_cache");
        if (cached) {
            summary = JSON.parse(cached);
        }
    } catch (e) {
        summary = null;
    }

    const hasSummary = Boolean(summary && Number(summary.totalValue) > 0);
    const currSymbol = getCurrencySymbol(
        summary?.currency || currency || "USDT"
    );

    return (
        <div
            data-testid="imported-binance-card"
            style={{
                padding: "20px",
                borderRadius: Tokens.radiusCard,
                border: `1px solid ${Tokens.hairline}`,
                backgroundColor: Tokens.card,
                marginBottom: "16px",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "12px",
                    width: "100%",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        minWidth: 0,
                        flex: 1,
                    }}
                >
                    <div
                        style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: Tokens.radiusControl,
                            backgroundColor: Tokens.accentSubtle,
                            border: `1px solid ${Tokens.accentBorder}`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: Tokens.accent,
                            fontFamily: Tokens.fontMono,
                            fontWeight: 600,
                            fontSize: "13px",
                            flexShrink: 0,
                        }}
                    >
                        BN
                    </div>
                    <div style={{ minWidth: 0, flex: 1 }}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                flexWrap: "wrap",
                            }}
                        >
                            <span
                                style={{
                                    color: Tokens.textPrimary,
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    lineHeight: 1.25,
                                }}
                            >
                                {name}
                            </span>
                            {hasSummary && PerformanceTag(summary.roiPct, true)}
                        </div>
                        <div
                            style={{
                                color: Tokens.textSecondary,
                                fontSize: "13px",
                                marginTop: "2px",
                            }}
                        >
                            Live Spot, Earn, and Funding wallet
                        </div>
                    </div>
                </div>
                <ArrowRightOutlined
                    style={{
                        color: Tokens.textSecondary,
                        fontSize: "14px",
                        flexShrink: 0,
                    }}
                />
            </div>

            {hasSummary && (
                <div
                    data-testid="binance-card-summary-grid"
                    style={{
                        marginTop: "14px",
                        paddingTop: "12px",
                        borderTop: `1px solid ${Tokens.hairline}`,
                        display: "grid",
                        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                        gap: "12px",
                        alignItems: "start",
                        fontVariantNumeric: "tabular-nums",
                    }}
                >
                    <div style={{ minWidth: 0 }}>
                        <div
                            style={{
                                color: Tokens.textMuted,
                                fontSize: "11px",
                                marginBottom: "2px",
                            }}
                        >
                            Balance
                        </div>
                        <div
                            style={{
                                color: Tokens.textPrimary,
                                fontSize: "14px",
                                fontWeight: 600,
                                fontFamily: Tokens.fontMono,
                                fontVariantNumeric: "tabular-nums",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {currSymbol}
                            {getFormattedAmount(summary.totalValue, true, 2)}
                        </div>
                    </div>

                    <div style={{ minWidth: 0 }}>
                        <div
                            style={{
                                color: Tokens.textMuted,
                                fontSize: "11px",
                                marginBottom: "2px",
                            }}
                        >
                            Invested
                        </div>
                        <div
                            style={{
                                color: Tokens.textSecondary,
                                fontSize: "14px",
                                fontWeight: 500,
                                fontFamily: Tokens.fontMono,
                                fontVariantNumeric: "tabular-nums",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {currSymbol}
                            {getFormattedAmount(summary.invested, true, 2)}
                        </div>
                    </div>

                    <div style={{ minWidth: 0, textAlign: "right" }}>
                        <div
                            style={{
                                color: Tokens.textMuted,
                                fontSize: "11px",
                                marginBottom: "2px",
                            }}
                        >
                            Holdings
                        </div>
                        <div
                            style={{
                                color: Tokens.textPrimary,
                                fontSize: "14px",
                                fontWeight: 500,
                                fontFamily: Tokens.fontMono,
                                fontVariantNumeric: "tabular-nums",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {summary.assetCount || 0} assets
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ImportedPortfolioCard;
